import { inject, Injectable } from '@angular/core';
import { CONFIG_TOKEN } from '@pxl/models/common';
import { LoginService, SelfCheckInService } from '@pxl/models/contracts';
import {
    CheckInFeatureStateModel,
    CheckInRequestModel,
    CheckInResponseModel,
    CheckInService,
    CheckInUnregisteredRequestModel,
    CheckInUnregisteredResponseModel,
} from '@pxl/shared/generated';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DefaultSelfCheckInService implements SelfCheckInService {
    protected readonly checkInBackendService = inject(CheckInService);
    protected config = inject(CONFIG_TOKEN);
    protected loginService = inject(LoginService);

    public finishCheckInWithoutRegisteringUser(requestModel: CheckInUnregisteredRequestModel): Promise<CheckInUnregisteredResponseModel[]> {
        return firstValueFrom(this.checkInBackendService.checkInUnregistered(requestModel, this.config.API_VERSION));
    }

    public getCheckInFeatureState(veterinarianId: string): Promise<CheckInFeatureStateModel> {
        return firstValueFrom(this.checkInBackendService.getCheckInFeatureState(veterinarianId, this.config.API_VERSION ?? ''));
    }

    public checkIn(checkInRequestModel: CheckInRequestModel): Promise<CheckInResponseModel[]> {
        return firstValueFrom(
            this.checkInBackendService.checkIn(checkInRequestModel, this.config.API_VERSION, this.loginService.getToken() ?? ''),
        );
    }
}
